// extracted by mini-css-extract-plugin
module.exports = {"scoreCircle":"score-module--scoreCircle--2N_3v","scoreNumber":"score-module--scoreNumber--1Lsy6"};